export default {
    methods: {
        renderRequiredHeader: function (h, _a) {
            var column = _a.column, $index = _a.$index;
            return this.$createElement('span', {}, [
                this.$createElement('span', column.label),
                this.$createElement('span', {
                    'class': {
                        're-lb': true,
                        'has-sortable': column.sortable
                    }
                })
            ]);
        }
    }
};
